import { Component, EventEmitter, Input, OnInit, Output, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { CryptoDataService } from 'app/core/services/crypto.data.service';
import { IConetionConfiguration } from 'app/datavisualization/core/interfaces/IConetionConfiguration';
import { IReportConfiguration } from 'app/datavisualization/core/interfaces/IReportConfiguration';
import { PowerBIService } from 'app/datavisualization/core/services/powerbi.service';
import { BzgToastService, BzgToastType } from 'bz-genome-angular';

@Component({
  selector: 'dv-powerbi-detail',
  templateUrl: './dv-power-bi-detail.component.html',
  styleUrls: ['./dv-power-bi-detail.component.scss']
})
export class PowerBIDetailComponent implements OnInit {
  showEncryptFlag: boolean = false;
  onSave: boolean = false;

  @Input() powerBIConfiguration: IConetionConfiguration;
  @Input() reportConfiguration: IReportConfiguration;
  @Input() isConexion: boolean = true;

  @Output() updateTable = new EventEmitter();

  constructor(private _toastService: BzgToastService,
              private _translateService: TranslateService,
              private _cryptoDataService: CryptoDataService,
              private powerBIServices: PowerBIService) { }

  ngOnInit() {
    this.cleanDescription();
  }

  encryptBasicSecurityPassword() {
    if (this.powerBIConfiguration.SecretId && (this.powerBIConfiguration.SecretId.length > 0)) {
      this._cryptoDataService.encryptString(this.powerBIConfiguration.SecretId).subscribe(result => {
        this.powerBIConfiguration.SecretId = result.encryptedPassword;
      });
    }
  }

  updateData() {
    this.onSave = true;
    if (this.isConexion) this.saveConexionConfiguration();
    else this.saveEnvironment();
  }

  saveConexionConfiguration() {
    const conectionToSend = this.powerBIConfiguration;
    conectionToSend.ReportEnvironments  = [];
    this.powerBIServices.saveConfig(conectionToSend).subscribe(response => {
      this.responseSave(response);
    });
  }

  saveEnvironment() {
    const reportEnvironementToSend = this.reportConfiguration;
    this.powerBIServices.saveEnvironment(reportEnvironementToSend).subscribe(response => {
      this.responseSave(response);
    });
  }

  responseSave(response: any) {
    this.onSave = false;
    if (response.Successful) {
      this.showToast('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY', 'success',5000);
      this.updateTable.emit();
    }
    else this.showToast(response.Exception.Message, 'error',0);
  }

  showToast(messageInput: string, type: BzgToastType, duration: number) {
    this._translateService.get(messageInput).subscribe((message: string) => {
      this._toastService.open(
        message,
        {
          type,
          duration: duration,
          verticalPosition: 'top',
          horizontalPosition: 'right'
        });
      }
    );
  }

  btnDisabled() {
    let disabled = true;
    if (this.isConexion) {
      const clientId = this.showErrorGuid(this.powerBIConfiguration.ClientId);
      const secretId = this.passwordEncrypt(this.powerBIConfiguration.SecretId);
      if (this.powerBIConfiguration.ClientId && this.powerBIConfiguration.SecretId  && !clientId && !secretId)
        disabled = false;
    } else {
      const workspaceId = this.showErrorGuid(this.reportConfiguration.GroupId);
      const reportId = this.showErrorGuid(this.reportConfiguration.ReportId);
      if (this.reportConfiguration.GroupId && this.reportConfiguration.ReportId && !workspaceId && !reportId)
        disabled = false;
    }
    if (this.onSave)
      disabled = true;
    return disabled;
  }

  showErrorGuid(guid) {
    let showError = true;
    if (guid) {
      if (guid.length === 0)
        showError = false;
      if (guid.length === 36)
      {
        const regex = /\b[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\b/g;
        const guidValid = guid.match(regex);
        if (guidValid)
          showError = false;
      }
    }
    if (guid === '00000000-0000-0000-0000-000000000000')
      showError = true;
    return showError;
  }

  showErrorLength(guid) {
    let showError = true;
    if (guid.length === 0)
      showError = false;
    if (guid.length > 10 && guid.length <= 20)
      showError = false;
    return showError;
  }

  showErrorRequired(value) {
    return value.length === 0;
  }

  showEncrypt() {
    this.showEncryptFlag = !this.showEncryptFlag;
  }

  passwordEncrypt(value) {
    const regex = /^CRYPT.[1-9].BIZAGI:/g;
    return !value.match(regex);    
  }

  cleanDescription() {
    this.powerBIConfiguration.Description = this.powerBIConfiguration.Description.replace(/\\n/g, '<br/>');
  }
}
